import
  styled
from 'styled-components';

export const NoMarginParagraph = styled.p`
  margin: 0px;
`

export const InputLabel = styled(NoMarginParagraph)`
color: ${props => props.disabled ? '#6D6F81' : '#08081B'};

font-size: 16px;
font-style: normal;
font-weight: bold;
font-family: 'RobotoMedium';
font-weight: 500;
display: flex;
flex-direction: column;
align-items: flex-start;
gap: 8px;

`;

export const Input = styled.input`
display: flex;
font-family: "RobotoRegular";
font-weight: 400;
padding: 16px;
align-items: center;
align-self: stretch;
border-radius: 8px;
border: 1px solid ${props => props.isError ? '#BD0000' : '#8A8D9C'};
box-shadow: none;
color: #08081B;

::placeholder {
  color: #8A8D9C;
}

&:focus {
  outline: none;
  color: #08081B;
  border: 1px solid ${props => props.isError ? '#BD0000' : '#08081B'};
}

&:hover {
  outline: none;
  border: 1px solid ${props => props.isError ? '#BD0000' : '#8A8D9C'};
}

&:disabled {
  background: #F5F6F7;
  ::placeholder {
    color: #A8ACB8;
  }
  &:hover {
    border: 1px solid #8A8D9C;
  }
}
`;

export const ForgotCredential = styled(NoMarginParagraph)`
font-size: 16px;
font-family: "VodafoneRegular";
font-style: normal;
font-weight: 400;
color: #4a4a4a;
text-decoration: underline;
`

export const OptionalText = styled(NoMarginParagraph)`
color: #6D6F81;

font-size: 12px;
font-style: normal;
font-weight: 500;
line-height: 150%;
`;

export const HFlexContainer = styled.article`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
`;

export const SpaceInbetweenSection = styled.section`
display: flex;
justify-content: space-between;
align-self: stretch;
`;

export const SmallText = styled(NoMarginParagraph)`
  display: flex;
  flex-direction: column;
  align-self: stretch;
  font-family: "RobotoRegular";
  color: ${props => !props.isError ? props.color : '#BD0000'};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 21px */
`;

export const Heading = styled(NoMarginParagraph)`
  align-self: stretch;
  color: var(--Greyscale-GREY-800, #222739);
  font-size: 26px;
  font-style: normal;
  font-weight: 900;
  font-family: "RobotoBlack";
`;

export const SubHeading = styled(NoMarginParagraph)`
  align-self: stretch;
  color: var(--Greyscale-GREY-800, #222739);
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  font-family: "RobotoRegular";
`;

export const PrimaryButton = styled.button`
  display: flex;
  padding: var(--12px, 12px) 16px;
  justify-content: center;
  align-items: center;
  gap: var(--8px, 8px);
  min-width: 195px;
  width: 200px;
  cursor: ${props => props.disabled ? '' : 'pointer'};

  border: 1px solid ${props => props.disabled ? '#D8DBE0' : '#E60000'};
  border-radius: 38px;
  background: ${props => props.disabled ? '#D8DBE0' : '#E60000'};
  color: ${props => props.disabled ? '#A8ACB8' : '#FFF'};
  // margin-top: ${props => !props.isChangePassword ? '15px' : '0'};   
  font-size: 16px; 
  font-style: normal;
  font-weight: 700;
  font-family: "RobotoBold";
  &:hover {
    background: ${props => props.disabled ? '#D8DBE0' : 'rgb(174 3 3)'}
  }

  @media screen and (max-width:480px) {
    width: 100%;
    min-width: 120px;
  }
`;

export const SecondaryButton = styled.button`
  display: flex;
  padding: var(--12px, 12px) 16px;
  justify-content: center;
  align-items: center;
  gap: var(--8px, 8px);
  width: 200px;
  min-width: 195px;
  font-family: "RobotoBold";
  background: none;
  border-radius: 50px;
  border: 1px solid ${props => props.disabled ? '#A8ACB8' : '#08081B'};
  color: ${props => props.disabled ? '#A8ACB8' : '#08081B'};
  font-size: 16px; 
  font-style: normal;
  font-weight: 700;

  &:hover {
    background: ${props => props.disabled ? '#A8ACB8' : 'rgb(243 243 243)'}
  }

  @media screen and (max-width:480px) {
    width: 100%;
    min-width: 120px;
  }
`;

export const MediumItalicText = styled(NoMarginParagraph)`
  color: #08081B;

  font-size: 14px;
  font-style: italic;
  font-weight: 400;
  line-height: 21px;
`;

export const LargeBoldText = styled(NoMarginParagraph)`
  color: var(--Greyscale-BLACK, #08081B);
  font-size: 18px;
  font-family: 'RobotoMedium';
  font-style: normal;
  font-weight: 500;
  line-height: 150%;`;

export const SmallBoldText = styled(NoMarginParagraph)`
  color: var(--Greyscale-GREY-600, #525365);
  cursor: pointer;
  font-size: ${props => props.fontSize ? props.fontSize : '14px'};
  font-family: 'RobotoMedium';
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
`;

export const XLargeBoldText = styled(NoMarginParagraph)`
  color: var(--Greyscale-BLACK, #08081B);
  text-align: center;
  font-family: "RobotoBold";
  font-size: 26px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%;
`;

export const GradientTextColor = styled.label`
  background: var(--gradients-purpleredgradient, radial-gradient(860.13% 207.15% at 125.1% 126.2%, #E60000 0%, #9C2AA0 100%));
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-family: "RobotoMedium";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
`;

export const RegularText = styled.label`
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  font-family: 'RobotoRegular';
  color: var(--Greyscale-GREY-700, #393949);
`;

export const RegularUnderlinedText = styled.span`
  color: ${props => props.color ? props.color : '#BD0000'};
  text-align: right;
  font-family: 'RobotoRegular';
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  text-decoration-line: underline;
  cursor: pointer;

  &:hover {
    color: blue;
  }
`;

export const XSmallBlackText = styled(NoMarginParagraph)`
  color: var(--Greyscale-BLACK, #08081B);
  font-family: "RobotoRegular";
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 18px */
`;

export const XXLBoldText = styled(NoMarginParagraph)`
align-self: stretch;

color: var(--Greyscale-GREY-800, #222739);
font-size: 26px;
font-style: normal;
font-weight: 900;
line-height: 150%; /* 39px */
`;
export const InputContainer = styled.div`
  position: relative;
  width: 100%
`;

export const SvgIcon = styled.div`
  position: absolute;
  top: 50%;
  right: 8px;
  transform: translateY(-50%);
  width: 24px;
  height: 24px; 
  cursor: pointer;
`;
